import React from 'react';
import { PageHeader as PageHeaderNew } from './PageHeader';
import { convertOldPageHeaderProps } from './converter.old';
import type { OldPageHeaderProps } from './converter.old';

export type PageHeaderProps = OldPageHeaderProps;

export const PageHeader = (props: PageHeaderProps) => <PageHeaderNew {...convertOldPageHeaderProps(props)} />;
